import React from 'react';
import PropTypes from 'prop-types';

const Pin = props => (
  <svg
    width="17px"
    height="28px"
    viewBox="0 0 17 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>shopping</title>
    <desc>Created with Sketch.</desc>
    <defs />
    <g
      id="LOCATION-📳"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Artboard" transform="translate(-97.000000, -106.000000)">
        <g id="shopping" transform="translate(97.000000, 106.000000)">
          <path
            d="M8.43144102,0.0975942767 C9.94594522,0.0975942767 11.3373751,0.533565006 12.6057724,1.40551954 C13.8552383,2.27747408 14.8491168,3.45124143 15.5874376,4.92685681 C16.3257584,6.42482999 16.6949133,8.06810428 16.6949133,9.85672897 C16.6949133,11.2205553 16.410948,12.7855784 15.8430089,14.5518453 C15.3507951,16.0498185 14.6692784,17.6707353 13.7984385,19.4146444 C13.079049,20.8008285 12.2555497,22.2428856 11.3279158,23.7408587 C10.6842515,24.7916757 10.0027349,25.8201195 9.28334537,26.8262209 L8.43144102,28 L7.57953666,26.8262209 C6.86014716,25.8201195 6.17863049,24.7916757 5.5349662,23.7408587 C4.60733237,22.2428856 3.78383306,20.8008285 3.06444357,19.4146444 C2.19360365,17.6707353 1.51208697,16.0498185 1.01987311,14.5518453 C0.451934029,12.7855784 0.16796875,11.2205553 0.16796875,9.85672897 C0.16796875,8.06810428 0.537123613,6.42482999 1.27544441,4.92685681 C2.01376522,3.45124143 3.00764369,2.27747408 4.25710967,1.40551954 C5.52550694,0.533565006 6.91693681,0.0975942767 8.43144102,0.0975942767 Z"
            fill={props.fill}
          />
          <text
            id="0"
            font-family="DINCanfor-Medium, DIN Canfor"
            font-size="15"
            font-weight="400"
            fill="#FFFFFF"
          >
            <tspan x="4.43394102" y="16.0975943">
              {props.index}
            </tspan>
          </text>
        </g>
      </g>
    </g>
  </svg>
);

export default Pin;

Pin.propTypes = {
  index: PropTypes.number,
  fill: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Map/elements/Pin.js